<template>
    <v-layout column align-center class="title-card h-100">
        <v-card elevation="0" rounded="lg" :color="color" class="title-card__top w-100 mb-6 mb-lg-10">
            <div class="w-100 pa-12 pa-lg-20">
                <h4 class="tit--sm line-height-1 text-center white--text">
                    {{title}}
                </h4>
            </div>
        </v-card>
        <v-card elevation="0" rounded="lg" color="white" class="title-card__bottom w-100">
            <v-layout column align-center justify-center class="w-100 h-100 text-center pa-12 pa-md-20">
                <slot />
            </v-layout>
        </v-card>
    </v-layout>
</template>

<script>

export default {
    props: {
        title: { type: String, default: "" },
        color: { type: String, default: "" },
    },
    data: () => ({
    }),
};
</script>

<style lang="scss" scoped>
@media (min-width:576px){
}
@media (min-width:768px){
    .title-card__bottom{
        min-height: calc(100% - 54px);
    }
}
@media (min-width:1024px){
    .title-card__bottom{
        min-height: calc(100% - 78px);
    }
}
@media (min-width:1200px){
}

</style>
